import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { canadaPlanSet } from 'src/constants/planData/canadaPlanData'
import { useEPLImage } from 'src/modules/hooks/useEPLImage'
import styled from 'styled-components'

export default (props) => {
  const posterImg = useEPLImage()

  return (
    <StyledContainer>
      <CanadaTemplateDefault
        location={props.location}
        lang="en"
        market="canada"
        offerBanner={{
          title: ['Enter the code from NorthStar Bets', 'to claim your FREE Fubo subscription'],
        }}
        hasOfferInput={true}
        ctaText="Redeem offer"
        poster={posterImg}
        noVideo={true}
        pageTitle="Watch the Premier League all season"
        title={
          <>
            Watch Premier League{' '}
            <span className="desktop-line-break"> and International Soccer </span>
            live all season
          </>
        }
        subtitle="Unlock your FREE Fubo subscription now!"
        hasPlanCardsTabs={false}
        networkSet="canada_sports"
        logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-northstar-v2.png?ch=width&auto=format,compress"
        logoHeight="60px"
        planCardsConfig={{
          plans: canadaPlanSet.sports,
        }}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  .content-container .hero-content {
    max-width: 800px;
  }
`
